const modules = {
  common:{
    state(){
      return {
        permissions:[],
        components:"",
        userInfo:{}
      }
    },
    mutations:{
      setItem(state,data){
        for(let key in data){
          state[key] = data[key];
        }
      }
    },
    actions:{
      setItem(context,data){
        context.commit("setItem",data)
      }
    }
  }
}

export default modules;